import { useMemo, useState } from "react";
import { Outlet } from "react-router";
import { GlobalHeader } from "@lending/components/GlobalHeader/GlobalHeader";
import { PageContent } from "@lending/components/PageContent";
import { PageLayout } from "@lending/components/PageLayout/PageLayout";
import styles from "./PortalLogin.module.css";
import { type PortalLoginChallenge, PortalLoginContext } from "./PortalLoginContext";

/**
 * Layout route for the Loan Portal verified identity login steps.
 *
 * Owning the challenge here keeps it alive while the user moves between the
 * child step routes, since the layout stays mounted across those transitions,
 * and drops it on refresh.
 *
 * The header is shared with the product flows; only `MainLayout` is not, since
 * it is mounted per flow, so the page/body wrappers stand in for it here.
 */
export function PortalLoginLayout() {
  const [challenge, setChallenge] = useState<PortalLoginChallenge | null>(null);

  const value = useMemo(() => ({ challenge, setChallenge }), [challenge]);

  return (
    <PortalLoginContext.Provider value={value}>
      <div className={styles.page}>
        <GlobalHeader flowType="web" />
        <div className={styles.body}>
          <PageLayout>
            <PageContent>
              <div className={styles.narrow}>
                <Outlet />
              </div>
            </PageContent>
          </PageLayout>
        </div>
      </div>
    </PortalLoginContext.Provider>
  );
}
